import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[numbersOnly]'
})
export class NumbersOnlyDirective {

  // Allow decimal numbers and negative values
  private regex: RegExp = new RegExp(/^[\s\d]+$/);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Shift', 'Control', 'ArrowRight', 'ArrowLeft','A', 'V', 'Delete'];

  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    //metakey for mac
    //ctrl + v, ctrl + c support
    if (this.specialKeys.indexOf(event.key) !== -1 ||
      (event.ctrlKey || event.metaKey) && event.keyCode == 86 ||
      (event.ctrlKey || event.metaKey) && event.keyCode == 67 ||
      (event.ctrlKey || event.metaKey) && event.keyCode == 65)  {
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (window.getSelection().toString() && String(next).match(this.regex)) {
      return;
    }
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

}
